import React, { useRef } from "react";
import { User, ChevronDown } from "lucide-react";

function initiales(user) {
  return `${user.name?.[0] || ""}${user.lastName?.[0] || ""}`.toUpperCase();
}

// Tronque à n lettres (+ ".") au-delà — évite qu'un prénom ou nom long
// fasse déborder la cellule une fois le collaborateur affecté.
function tronque(str, n) {
  if (!str) return "";
  return str.length > n ? `${str.slice(0, n)}.` : str;
}

// Prénom (user.lastName) + nom (user.name), tronqués à 4 lettres chacun
// (ex. "Ophélie RIVIER" -> "Ophé. Rivi.").
function nomCourt(user) {
  return `${tronque(user.lastName, 4)} ${tronque(user.name, 4)}`.trim();
}

// Simple déclencheur : le menu déroulant lui-même est géré et rendu par
// SuiviTraitementsComptables (position fixed, hors du tableau) — même
// principe que le menu "..." de ToDo.js (handleMenuToggle) — pour ne jamais
// être coupé par le conteneur scrollable du tableau (.pieces-wrap).
function CollaborateurCell({ assignee, canEdit, onToggle }) {
  const triggerRef = useRef(null);

  return (
    <div className="ir-collab-cell">
      <button
        type="button"
        ref={triggerRef}
        className={`ir-collab-trigger ${assignee ? "is-set" : "is-empty"}`}
        disabled={!canEdit}
        onClick={(e) => {
          e.stopPropagation();
          onToggle(triggerRef.current?.getBoundingClientRect());
        }}
      >
        {assignee ? (
          <>
            <span className="ir-collab-avatar">{initiales(assignee)}</span>
            <span className="ir-collab-name">{nomCourt(assignee)}</span>
          </>
        ) : (
          <>
            <span className="ir-collab-avatar ir-collab-avatar-empty">
              <User size={11} />
            </span>
            <span className="ir-collab-name ir-collab-empty-label">Affecter…</span>
          </>
        )}
        <span className="ir-collab-chev">
          <ChevronDown size={12} />
        </span>
      </button>
    </div>
  );
}

export default CollaborateurCell;
